import { useEffect, useState } from "react";
import { api, money } from "@/lib/api";
import { useCart } from "@/context/CartContext";
import { Layers, Plus } from "lucide-react";

const SET_ID = "HOPE_CARDS_SET";

export const CartSetNudge = () => {
  const { items, addItem, removeItem } = useCart();
  const [cards, setCards] = useState([]);
  const [live, setLive] = useState(false);

  useEffect(() => {
    api.get("/hope-cards").then((r) => setCards(r.data)).catch(() => {});
    api.get("/settings").then((r) => setLive(!!r.data.hope_cards_live)).catch(() => {});
  }, []);

  if (!live || cards.length === 0) return null;
  const cardIds = new Set(cards.map((c) => c.id));
  const cardsInCart = items.filter((i) => cardIds.has(i.id));
  const setInCart = items.some((i) => i.id === SET_ID);
  if (setInCart || cardsInCart.length === 0 || cardsInCart.length >= cards.length) return null;

  const individualTotal = cards.reduce((s, c) => s + Number(c.price || 0), 0);
  const setPrice = Math.round(individualTotal * 0.8 * 100) / 100;
  const savings = Math.round((individualTotal - setPrice) * 100) / 100;

  const addSet = () => {
    cardsInCart.forEach((i) => removeItem(i.lineKey));
    addItem({ id: SET_ID, name: "The Collector's Set", price: setPrice, image: cards[0]?.image || "", slug: "collectors-set" }, 1);
  };

  return (
    <div className="bg-[#8E9A86]/10 border border-[#8E9A86]/40 rounded-xl p-4 flex items-center gap-3" data-testid="cart-set-nudge">
      <Layers className="h-5 w-5 text-[#8E9A86] shrink-0" />
      <div className="flex-1 text-sm text-[#3A3632]">
        <span className="font-medium">Complete the set &amp; save {money(savings)}.</span> Get all {cards.length} Hope Cards as the Collector's Set for {money(setPrice)}.
      </div>
      <button onClick={addSet} data-testid="cart-add-set" className="shrink-0 text-xs inline-flex items-center gap-1 bg-[#8E9A86] text-white rounded-full px-3 py-1.5 font-medium hover:bg-[#7A8772] transition-colors">
        <Plus className="h-3 w-3" /> Add set
      </button>
    </div>
  );
};
